import { render } from "./Options.vue?vue&type=template&id=b5cd2bf8&scoped=true"
import script from "./Options.vue?vue&type=script&lang=js"
export * from "./Options.vue?vue&type=script&lang=js"

import "./Options.vue?vue&type=style&index=0&id=b5cd2bf8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5cd2bf8"]])

export default __exports__